import { render, staticRenderFns } from "./BaseImg.vue?vue&type=template&id=65d85dea&scoped=true&"
import script from "./BaseImg.vue?vue&type=script&lang=ts&"
export * from "./BaseImg.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d85dea",
  null
  
)

export default component.exports